import { useTranslation } from 'react-i18next'
import Input from "components/common/Input/Input"
import InputError from "components/common/InputError/InputError"

const LastName = ({ register, error }) => {
  const { t } = useTranslation()

  return (
    <>
      <Input
        error={error}
        register={register('lastname', {
          required: t('mainReporting:form.mandatory'),
          validate: value => value.length < 21 || t('mainReporting:form.lastName.errors.length')
        })}
        label={t('mainReporting:form.lastName.label')}
        placeholder={t('mainReporting:form.lastName.placeholder')}
        allowOnly={/[\p{L} '-]+/gu}
        autocomplete="family-name"
      />
      <InputError error={error} />
    </>
  )
}

export default LastName
